import React, { useState } from "react";
import TeamCard from "../../cards/team";
import {graphql} from "gatsby";
import parse from "html-react-parser";
import { Close } from "../../icons";
import StructuredText from "../custom-structured-text-renderer";
import { Asset } from "../../../../plugins/gatsby-plugin-atollon";

const TeamSelector = ({title, items}) => {
  const [popup, setPopup] = useState(false);
  const [profile, setProfile] = useState(null);
  const toggle = (item) => {
    setPopup(true);
    setProfile(item);
};
  return (
    <>
      <section className='team-archive'>
          <div className='team-archive__inner'>
              {title && <h4 data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>{parse(title)}</h4>}
              <div className='team-archive__items'>
                  {
                      items?.length > 0 && items.map((el, i) => (
                          <TeamCard onClick={() => toggle(el)} key={i} {...el} />
                      ))
                  }
              </div>
          </div>
      </section>
      <div className={`team-overlay ${popup ? 'active' : ''}`}>
        <button onClick={() => setPopup(false)}><Close color='#FFFFFF'/></button>
        <div className='team-overlay__inner'>
            <div className='team-overlay__content'>
                {profile?.sector.length > 0 && <span>{profile.sector[0].option}</span>}
                {profile?.title && <h3>{profile.title}</h3>}
                {profile?.jobTitle && <h4>{profile.jobTitle}</h4>}
                {profile?.biography && <StructuredText data={profile.biography}/>}
            </div>

            <div className='team-overlay__image'>
                {profile?.image && <Asset asset={profile.image}/>}
            </div>
        </div>
    </div>
    </>

  )
}

export default TeamSelector

export const query = graphql`
fragment TeamSelectorProps on DatoCmsTeamSelector {
  ... on DatoCmsTeamSelector {
    id
    title
    items {
      jsonLd
      jobTitle
      title
      slug
      permalink
      brand
      biography {
        value
      }
      sector {
        option
      }
      image {
        ...InternalAssetProps
      }
    }
  }
}
`